import React, { useCallback, useContext, useEffect, useState } from "react";

import {
  ActionItem,
  ActionOnItem,
  ArtifactType,
  ContentSubstate,
  getArtefactIcon,
  getContentAdminActionableEditItems,
  getContentHistoryStatusString,
  SKArtifact,
  SKArtifactPayload,
} from "../../models/SKArtifact";

import TextArtifactContainer from "../artifacts/create/container/TextArtifactContainer";
import DocumentArtifactContainer from "../artifacts/create/container/DocumentAtrifactContainer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CreateArtifactContext } from "../../context/CreateArtifactContext";
import PhotoArtifactContainer from "../artifacts/create/container/PhotoArtifactContainer";
import VideoArtifactContainer from "../artifacts/create/container/VideoArtifactContainer";
import AudioArtifactContainer from "../artifacts/create/container/AudioArtifactContainer";
import LinkArtifactContainer from "../artifacts/create/container/LinkArtifactContainer";
import EventArtifactContainer from "../artifacts/create/container/EventArtifactContainer";
import LoadingPopup from "../channels/create/LoadingPopup";

import {
  deleteArtifact,
  deleteArtifactEdit,
  updateArtifact,
  updateArtifactEditStatus,
  updateArtifactStatus,
  updateStatusHistory,
} from "../../api/artifacts/atrifactService";

import { capitalizeFirstLetter } from "../../utils/stringFunctions";
import { useNavigationBar } from "../../context/NavigationContext";
import ActionPopup from "../../components/ActionPopup";
import ArtifactStateDialog, { DialoageContent } from "../artifacts/create/container/components/ArtifactStateDialog";
import ArtifactModerationDialog from "./ArtifactModerationDialog";
import { ContentState } from "../../models/SKArtifact";

import PlaceArtifactContainer from "../artifacts/create/container/PlaceArtifactContainer";
import LetterArtifactContainer from "../artifacts/create/container/LetterArtifactContainer";
import { getArtifact } from "../../api/artifacts/atrifactService";
import ListArtifactContainer from "../artifacts/create/container/ListArtifactContainer";
import GreetingsArtifactContainer from "../artifacts/create/container/GreetingsArtifactContainer";
import GuideArtifactContainer from "../artifacts/create/container/GuideArtifactContainer";
import PollsArtifactContainer from "../artifacts/create/container/PollsArtifactContainer";
import StoryArtifactContainer from "../artifacts/create/container/StoryArtifactContainer";
import JournalArtifactContainer from "../artifacts/create/container/JournalArtifactContainer";
import { useUpdateList } from "./UpdateListContext";

// import JournalArtifactContainer from "../artifacts/create/container/JournalArtifactContainer";

const options = [
  {
    title: "Request for more Information",
    value: "Request for more Information",
  },
  { title: "Not Supported", value: "Not Supported" },
  { title: "Do not meet Guidelines", value: "Do not meet Guidelines" },
  { title: "Multiple Non Approvals", value: "Multiple Non Approvals" },
  { title: "Violent or Gore", value: "Violent or Gore" },
  {
    title: "Hate Speech or Discrimination",
    value: "Hate Speech or Discrimination",
  },
  { title: "Harassment or Bullying", value: "Harassment or Bullying" },
  { title: "Nudity or Sexual Acts", value: "Nudity or Sexual Acts" },
  {
    title: "Misleading or False Information",
    value: "Misleading or False Information",
  },
  { title: "Abusive or Exploitive", value: "Abusive or Exploitive" },
  { title: "Spam", value: "Spam" },
  {
    title: "Obscene or Explicit Language",
    value: "Obscene or Explicit Language",
  },
  { title: "Privacy Violation", value: "Privacy Violation" },
  {
    title: "Copyright Infringement or Illegal",
    value: "Copyright Infringement or Illegal",
  },
  { title: "Other", value: "Other" },
];

export default function ShowArtifactEdits() {
  // const [artifactdata, setArtifactData] = useState<SKArtifact | null>(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const {
    contentData,
    updateContentData,
    setArtifactId,
    artifactId,
    isModerator,
    loading,
    containerButtonTitle,
    getContentActionableAdminItems,
    submit,
  } = useContext(CreateArtifactContext);
  const [actionOnItem, setActionOnItem] = useState<ActionOnItem | null>(null);
  const [dialogContent, setDialogContent] = useState<DialoageContent | null>(null);
  const moderationDialogActions = [ActionItem.delete, ActionItem.reject, ActionItem.withdraw];
  const { setNavProps } = useNavigationBar();
  const { updateList } = useUpdateList();

  // const memoizedContainerButtonTitle = useCallback(() => containerButtonTitle(), [containerButtonTitle]);
  // const memoizedGetActionableAdminItems = useCallback(() => getActionableAdminItems(), [getActionableAdminItems]);

  function getModerationDialogContent(action: ActionItem): DialoageContent | null {
    switch (action) {
      case ActionItem.delete:
        return {
          message: "Are you sure you will like to Delete this Content?",
          description: "Content will be permanently deleted form the system and you will not be able to recover it.",
          actionTitle: ActionItem.delete,
          destructiv: true,
        };
      case ActionItem.reject:
        return {
          message: "Are you sure you will like to Reject content?",
          description: "Content will move back to draft state. User can submit again.",
          actionTitle: ActionItem.reject,
          destructiv: true,
        };
      case ActionItem.reject_edit:
        return {
          message: "Are you sure you will like to Reject Edits?",
          description: "Content edits will be discarded. This action cannot be undone.",
          actionTitle: ActionItem.reject_edit,
          destructiv: true,
        };

      case ActionItem.approve_edit:
        return {
          message: "Are you sure you will like to Approve Content edits?",
          description: "Edits will be immediatly available to the public.",
          actionTitle: ActionItem.approve_edit,
          destructiv: false,
        };
      case ActionItem.approve:
        return {
          message: "Are you sure you will like to Approve this content?",
          description: "Content will be available to the public after approval.",
          actionTitle: ActionItem.approve,
          destructiv: false,
        };
      default:
        return null;
    }
  }

  const updateStatus = async (actionItem: ActionItem, reason?: string, note?: string) => {
    if (!artifactId) return;

    var data: any = {};
    switch (actionItem) {
      case ActionItem.delete:
        deleteArtifact(artifactId);
        break;
      case ActionItem.approve:
        await updateArtifactStatus(artifactId, ContentState.ACTIVE, ContentSubstate.NONE, reason, note);
        // await updateArtifact(contentId, { status: content?.autoPublish ? State.published : State.approved });
        //updateLocalStatus(artifactId, contentData?.autoPublish ? State.published : State.approved);
        updateList(artifactId, ContentState.ACTIVE, ContentSubstate.NONE);
        updateContentData({
          status: ContentState.ACTIVE,
          subStatus: ContentSubstate.NONE,
        });
        break;
      case ActionItem.reject:
        //await updateArtifact(contentId, { status: State.rejected });
        await updateArtifactStatus(artifactId, ContentState.DRAFT, ContentSubstate.REJECTED, reason, note);
        updateContentData({ status: ContentState.DRAFT, subStatus: ContentSubstate.REJECTED });
        updateList(artifactId, ContentState.DRAFT, ContentSubstate.REJECTED);
        break;

      //   case ActionItem.reject_edit:
      //     // await updateArtifact(contentId, { status: State.blocked });
      //     await updateArtifactStatus(artifactId, ContentState.ACTIVE, ContentSubstate.EDIT_REJECTED, reason, note);
      //     updateContentData({ status: ContentState.ACTIVE, subStatus: ContentSubstate.EDIT_REJECTED });
      //     updateList(artifactId, ContentState.ACTIVE, ContentSubstate.EDIT_REJECTED);
      //     break;
      //   case ActionItem.approve_edit:
      //     // await updateArtifact(contentId, { status: State.blocked });
      //     await updateArtifactStatus(artifactId, ContentState.ACTIVE, ContentSubstate.EDIT_APPROVED, reason, note);
      //     updateContentData({ status: ContentState.ACTIVE, subStatus: ContentSubstate.EDIT_APPROVED });
      //     updateList(artifactId, ContentState.ACTIVE, ContentSubstate.EDIT_APPROVED);
      //     break;

      case ActionItem.approve_edit:
        //await updateChannelStatus(contentId, ContentState.ACTIVE, ContentSubstate.EDIT_APPROVED);

        try {
          const {
            status,
            subStatus,
            channelStatus,
            flagged,
            loveCount,
            likeCount,
            shareCount,
            views,
            bookmarkCount,
            viewCount,
            reportCount,
            lastReportedDate,
            ...rest
          } = contentData;
          await updateArtifact(artifactId, { ...rest, status: ContentState.ACTIVE, subStatus: ContentSubstate.EDIT_APPROVED });
          await updateStatusHistory(
            artifactId,
            getContentHistoryStatusString(ContentState.ACTIVE, ContentSubstate.EDIT_APPROVED, true),
            reason,
            note
          );
          await deleteArtifactEdit(artifactId);
          updateList(artifactId, ContentState.ACTIVE, ContentSubstate.EDIT_APPROVED);
          updateContentData({ status: ContentState.ACTIVE, subStatus: ContentSubstate.EDIT_APPROVED });
        } catch (error) {
          console.log(error);
        }

        break;
      case ActionItem.reject_edit:
        await updateArtifactEditStatus(artifactId, ContentState.ACTIVE, ContentSubstate.EDIT_REJECTED, reason, note);
        updateList(artifactId, ContentState.ACTIVE, ContentSubstate.EDIT_REJECTED);
        updateContentData({ status: ContentState.ACTIVE, subStatus: ContentSubstate.EDIT_REJECTED });

        break;
    }
  };

  useEffect(() => {
    if (id && artifactId !== id) {
      setArtifactId(id);
    }
  }, [id, artifactId, setArtifactId]);

  useEffect(() => {
    if (actionOnItem?.action) {
      const contentDialog = getModerationDialogContent(actionOnItem.action);
      setDialogContent(contentDialog);
    }
  }, [actionOnItem]);

  //   useEffect(() => {
  //     const getArtifactLocal = async (artifactId: string) => {
  //       setLoading(true);
  //       let artifact = await getArtifact(artifactId);
  //       setArtifactData(artifact);
  //       setLoading(false);
  //     };

  //     if (artifactId) {
  //       getArtifactLocal(artifactId);
  //     }
  //   }, [artifactId]);

  useEffect(() => {
    // console.log("Dependencies changed:");
    // console.log("artifactId", artifactId);
    // console.log("contentData", contentData);
    // console.log("getActionableAdminItems", getActionableAdminItems);
    // console.log("containerButtonTitle", containerButtonTitle);
    setNavProps({
      backArrow: false,
      title: "Content",
      subtitle: capitalizeFirstLetter(contentData.type ?? ""),
      icon: contentData.type ? getArtefactIcon(contentData.type) : undefined,
      buttonTitle: "Submit",
      enableLink: false,
      getActionItems: () => getContentAdminActionableEditItems(contentData.status, contentData.subStatus),
      onActionItemSelect: actionItem =>
        setActionOnItem({
          itemid: artifactId!,
          action: actionItem as ActionItem,
        }),
      onNext: null,
      onClose: () => {
        navigate(-1);
      },
    });
  }, [artifactId, contentData, setNavProps]);

  const element = (): JSX.Element => {
    <LoadingPopup isLoading={loading} />;
    switch (contentData?.type) {
      case ArtifactType.text:
        return <TextArtifactContainer />;

      case ArtifactType.audio:
        return <AudioArtifactContainer />;

      case ArtifactType.document:
        return <DocumentArtifactContainer />;

      case ArtifactType.event:
        return <EventArtifactContainer />;

      case ArtifactType.greeting:
        return <GreetingsArtifactContainer />;

      // case ArtifactType.journal:
      //   return <JournalArtifactContainer />;

      case ArtifactType.letter:
        return <LetterArtifactContainer />;

      case ArtifactType.link:
        return <LinkArtifactContainer />;

      case ArtifactType.list:
        return <ListArtifactContainer />;

      case ArtifactType.photo:
        return <PhotoArtifactContainer />;

      case ArtifactType.place:
        return <PlaceArtifactContainer />;

      case ArtifactType.guide:
        return <GuideArtifactContainer />;

      case ArtifactType.poll:
        return <PollsArtifactContainer />;

      case ArtifactType.story:
        return <StoryArtifactContainer />;

      case ArtifactType.video:
        return <VideoArtifactContainer />;
      case ArtifactType.journal:
        return <JournalArtifactContainer />;
      default:
        break;
    }
    return <></>;
  };

  return loading ? (
    <LoadingPopup isLoading={loading} loadingText="Loading" />
  ) : (
    <>
      {actionOnItem?.action && dialogContent ? (
        moderationDialogActions.includes(actionOnItem.action) ? (
          <ArtifactModerationDialog
            contentId={actionOnItem.itemid}
            action={actionOnItem.action}
            onAction={(contendId, action, reason, note) => {
              updateStatus(action as ActionItem, reason, note);
              setActionOnItem(null);
              navigate(-1);
            }}
            onCancel={() => setActionOnItem(null)}
            options={options}
            dialogContent={dialogContent}
          />
        ) : (
          <ArtifactStateDialog
            action={actionOnItem?.action}
            onClose={() => setActionOnItem(null)}
            onUpdate={async () => {
              const action = actionOnItem?.action;
              await updateStatus(action);
              setActionOnItem(null);
              navigate(-1);
            }}
            dialogeContent={dialogContent}
          />
        )
      ) : (
        <></>
      )}
      {element()}
    </>
  );
}
